<figure class="promo-banner-figure hover-opacity hoverable-animated">
  <img [src]="imageUrl" [alt]="title" />
</figure>
